// extracted by mini-css-extract-plugin
export default {"invoiceMain":"invoice_invoiceMain__ulDvQ","clearance":"invoice_clearance__9aOnZ"};